<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { AgentChatFeedbackAbilitySubject } from '@/@vxapp/AiAgents/chatFeedbackContract'
import AiFeedbackPage from '@/components/AiWorkspace/Feedback/AiFeedbackPage.vue'

// The AI workspace layout, gated by the feedback read permission rather than chat access.
definePage({
  meta: {
    subject: AgentChatFeedbackAbilitySubject.AI_FEEDBACK,
    layout: PageMeta.AiWorkspace.Chat.Meta.layout,
    pageTitle: 'Response feedback',
  },
})
</script>

<template>
  <AiFeedbackPage />
</template>
